import styles from './style.postcss';

import React, { Component } from 'react';
import { Link } from 'react-router';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect, moment, testClass, ApiCall, Icon, PageLoadingSpinner } from 'omni-common-ui';
import * as studentNoteActions from 'containers/Student/Note/actions';
import UserCard from 'components/UserCard';
import StudentCardProfile from 'containers/StudentCardProfile';
import { accessors } from 'data/Users/Notifications';
import {
  accessors as idpAccessors,
  actions as individualDevelopmentPlans,
} from 'data/IndividualDevelopmentPlans';
import {
  actions as studentReportSummariesActions,
} from 'data/ProgressReports/StudentReportSummaries';
import {
  getProgressReportBasePath,
  getUnitReportBasePath,
} from 'domain/CourseType';

class NotificationCalloutSlide extends Component {
  constructor() {
    super();
    this._onLinkClicked = this._onLinkClicked.bind(this);
  }

  componentWillMount() {
    this._loadIfNeeded(this.props);
  }

  componentWillReceiveProps(props) {
    this._loadIfNeeded(props);
    if (props.notification !== this.props.notification && props.notification) {
      const { isUnitReport, isProgressReport, idpId } = props;
      const { entityId, studentId } = props.notification;
      if (isUnitReport && entityId && studentId) {
        this.props.fetchStudentReportSummary(`${entityId}`, studentId);
      } else if (isProgressReport && idpId) {
        this.props.fetchIdpLearningResult(idpId);
      }
    }
  }

  _loadIfNeeded({ noteId }) {
    this.props.fetchSingleStudentNoteIfNeeded(noteId);
  }

  _onLinkClicked() {
    if (! this.props.notificationsTray) return;
    this.props.notificationsTray.close();
  }

  _buildURL() {
    const { buildRoute, notification = {}, isUnitReport, isProgressReport } = this.props;
    const { fullCourseTypeLevelCode } = notification;
    if (isUnitReport) {
      const unitReportPath = getUnitReportBasePath({ fullCourseTypeLevelCode });
      return buildRoute(
        `/group/${notification.groupId}/${unitReportPath}/${notification.entityId}/student/${
          notification.studentId
        }`
      );
    } else if (isProgressReport) {
      const progressReportPath = getProgressReportBasePath({ fullCourseTypeLevelCode });
      return buildRoute(
        `/group/${notification.groupId}/${progressReportPath}/${notification.entityId}/student/${
          notification.studentId
        }`
      );
    }
    return buildRoute(`/student/${notification.studentId}`);
  }

  render() {
    const { notification, isLoading, isFailed } = this.props;

    if (isFailed) {
      return (
        <div className={classnames(styles.NotificationCalloutSlide, styles.__error)}>
          <h1>
            <Icon id="cross-circle" />
          </h1>
          <p>Omni could not load this content.</p>
        </div>
      );
    }
    const isStudent = notification &&
        ! accessors.isUnitReport(notification.category) &&
        ! accessors.isProgressReport(notification.category);

    return (
      <div className={styles.NotificationCalloutSlide}>
        <PageLoadingSpinner isAbsolutePositioned isHidden={! isLoading} />

        {/* notification view */}
        {notification ? (
          <div>
            {isStudent ? (
              <StudentCardProfile useLowerLevelPersonComponent
                  className={styles.NotificationCalloutSlide_studentProfile}
                  studentId={notification.studentId}
                  name={notification.studentName} />
            ) : (
              <UserCard id={notification.notedByUserId} />
            )}
            <p className={testClass('notification-content')}>{notification.content}</p>
            <p>
              <Link className={styles.NotificationCalloutSlide_openLink}
                  to={() => this._buildURL()}
                  onClick={this._onLinkClicked}>
                Open
              </Link>
              <span className={styles.NotificationCalloutSlide_timestamp}>
                &nbsp;• {moment.utc(notification.notedDateTimeUtc).fromNow()}
              </span>
            </p>
          </div>
        ) : null}
      </div>
    );
  }
}

NotificationCalloutSlide.propTypes = {
  noteId: PropTypes.string,
  category: PropTypes.string,
  notificationsTray: PropTypes.shape({
    close: PropTypes.func.isRequired,
  }),
  notification: PropTypes.object,
  fetchSingleStudentNoteIfNeeded: PropTypes.func,
  buildRoute: PropTypes.func,
  fetchIdpLearningResult: PropTypes.func,
  fetchStudentReportSummary: PropTypes.func,
  isUnitReport: PropTypes.bool,
  isProgressReport: PropTypes.bool,
  idpId: PropTypes.string,
  isLoading: PropTypes.bool,
  isFailed: PropTypes.bool,
};

function mapStateToProps(state, { noteId }) {
  const callState = studentNoteActions.getApiCallState(state, noteId);
  const notification = state.get('rootReducer').get('studentNotes').get(`${noteId}`);
  const { category, entityId, studentId } = notification || {};
  const isProgressReport = category && accessors.isProgressReport(category);
  const isUnitReport = category && accessors.isUnitReport(category);
  let idpId;
  if (isProgressReport) {
    idpId = idpAccessors.getIdpId(state, `${entityId}`, studentId);
  }
  return {
    idpId,
    notification,
    isProgressReport,
    isUnitReport,
    isLoading: ApiCall.State.isValue(callState) && ApiCall.State.isLoading(callState),
    isFailed: ApiCall.State.isValue(callState) && ApiCall.State.hasFailed(callState),
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign({},
    bindActionCreators(studentNoteActions, dispatch),
    bindActionCreators(individualDevelopmentPlans, dispatch),
    bindActionCreators(studentReportSummariesActions, dispatch));
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NotificationCalloutSlide);



// WEBPACK FOOTER //
// ./containers/NotificationCalloutSlide/index.jsx